import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetDailyCheckHistory } from "../../common/actions/moreAction";
import { isEmpty } from "../../common/cores";

const days = [
  {
    name: "일",
    value: "mon",
    className: "red-text"
  },
  {
    name: "월",
    value: "mon"
  },
  {
    name: "화",
    value: "mon"
  },
  {
    name: "수",
    value: "mon"
  },
  {
    name: "목",
    value: "mon"
  },
  {
    name: "금",
    value: "mon"
  },
  {
    name: "토",
    value: "mon",
    className: "red-text"
  },
]

const AttendanceContent = props => {

  const [dateArray, setDateArray] = useState([]);
  const [date, setDate] = useState(new Date(Date.now()));
  const { histories } = props.dailycheck


  const GetDateArray = (date) => {

    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const nextDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const lastDay = nextDay.getDate();

    // GetDateArray(date);

    let array = [], i, j, cnt = 1;
    for (i = 0; cnt <= lastDay; i++) {
      let temporary = [];
      if (i === 0) {
        for (j = 0; j < firstDay.getDay(); j++) temporary.push(0);
        for (; j < 7; j++) temporary.push(cnt++);
      } else for (j = 0; j < 7 && cnt <= lastDay; j++) temporary.push(cnt++);
      for (j = temporary.length; j < 7; j++) temporary.push(0);
      array.push(temporary);
    }
    setDateArray(array);
  }

  const ChangeDate = (param) => {
    const curDate = new Date(date);
    const now = new Date();
    curDate.setMonth(date.getMonth() + param);
    if (curDate > now)
      return;
    GetDateArray(curDate);
    setDate(curDate);

    props.GetDailyCheckHistory({
      year: curDate.getFullYear().toString(),
      month: (curDate.getMonth() + 1).toString()
    })
  }

  useEffect(() => {
    console.log(date)
    ChangeDate(0);
  }, [])

  return (

    <Fragment>
      <div data-v-8a9c4d9d="" className="rightContent homePage" style={{ float: "left", width: "100%" }}>
        <div data-v-8a9c4d9d="" className="contents" style={{ maxWidth: "1920px", margin: "auto" }}>
          <div data-v-8a9c4d9d="" className="main_content_continer">
            <div data-v-7f3aef84="" data-v-8a9c4d9d="" className="main-content padding-15">
              <div data-v-7f3aef84="" className="aniFrame">
                <div data-v-7f3aef84="" className="main_content">
                  <div data-v-0838e822="" className="main_content v_deep_deposit">
                    <div data-v-0838e822="" className="main_content_wrap main_content_wrap_notice deposit">
                      <div data-v-0838e822="">
                        <div data-v-0838e822="" className="fundFrame noticeFrame">

                          <div
                            data-v-394b74b4=""
                            className="scrollable-auto column"
                            style={{ width: "100%" }}
                          >
                            <div data-v-20f59104="" data-v-394b74b4="" className="attendance column attendance-view">
                              <div data-v-20f59104=""
                                className=" white-text text-align-center">
                                <p className="color-gray">
                                  <span style={{ fontSize: '1rem' }}>
                                    <span style={{ fontSize: '1rem' }}>
                                      {isEmpty(window.lang["하루 최소 충전"]) ? "하루 최소 충전" : window.lang["하루 최소 충전"]}
                                    </span>
                                    <span style={{ fontSize: '1rem' }}> {isEmpty(window.lang["300,000원"]) ? "300,000원" : window.lang["300,000원"]} </span>
                                    <span style={{ fontSize: '1rem' }}>
                                      {isEmpty(window.lang["이상 시 출석 체크를 할 수 있습니다."]) ? "이상 시 출석 체크를 할 수 있습니다." : window.lang["이상 시 출석 체크를 할 수 있습니다."]}
                                    </span>
                                  </span>
                                </p>
                                <p className="color-gray">
                                  <span style={{ fontSize: '1rem' }}>
                                    {isEmpty(window.lang["10일 출석 체크 시"]) ? "10일 출석 체크 시" : window.lang["10일 출석 체크 시"]}
                                  </span>
                                  <span
                                    className="color-green"
                                    style={{ color: 'rgb(56, 184, 83)', fontSize: '1rem' }}>
                                    &nbsp;30,000
                                  </span>
                                  <span style={{ fontSize: '1rem' }}>
                                    {isEmpty(window.lang["포인트가 지급됩니다."]) ? "포인트가 지급됩니다." : window.lang["포인트가 지급됩니다."]}
                                  </span>
                                </p>
                                <p className="color-gray">
                                  <span style={{ fontSize: '1rem' }}>
                                    {isEmpty(window.lang["20일 연속 출석 체크 시"]) ? "20일 연속 출석 체크 시" : window.lang["20일 연속 출석 체크 시"]}
                                  </span>
                                  <span className="color-blue" style={{ fontSize: '1rem' }}>
                                    <span style={{ fontSize: '1rem' }}>&nbsp;</span>

                                    <span style={{ color: 'rgb(73, 171, 255)', fontSize: '1rem' }}>
                                      50,000
                                    </span>
                                  </span>
                                  <span style={{ fontSize: '1rem' }}>
                                    {isEmpty(window.lang["포인트가 지급됩니다. (월 1회)"]) ? "포인트가 지급됩니다. (월 1회)" : window.lang["포인트가 지급됩니다. (월 1회)"]}
                                  </span>
                                </p>
                                <p className="color-gray">
                                  <span style={{ fontSize: '1rem' }}>
                                    {isEmpty(window.lang["30일 연속 출석체크 시"]) ? "30일 연속 출석체크 시" : window.lang["30일 연속 출석체크 시"]}
                                  </span>
                                  <span
                                    className="color-red"
                                    style={{ color: 'rgb(255, 108, 108) !important', fontSize: '1rem' }}>
                                    &nbsp;100,000
                                  </span>
                                  <span style={{ fontSize: '1rem' }}>
                                    {isEmpty(window.lang["포인트가 지급됩니다."]) ? "포인트가 지급됩니다." : window.lang["포인트가 지급됩니다."]}
                                  </span>
                                </p>
                              </div>
                              <div
                                data-v-20f59104=""
                                className="date row"
                                style={{ flexDirection: "row" }}
                              >
                                <span data-v-20f59104="" className="text">
                                  <span data-v-621a4120="" style={{ padding: "0px 5px", cursor: "pointer" }}
                                    onClick={e => { e.preventDefault(); ChangeDate(-1) }}>
                                    <i className="xi-angle-left font-size-22"></i>
                                  </span>
                                  {date.getFullYear()}{isEmpty(window.lang["년"]) ? "년" : window.lang["년"]} {date.getMonth() + 1}{isEmpty(window.lang["월"]) ? "월" : window.lang["월"]}
                                  <span data-v-621a4120="" style={{ padding: "0px 5px", cursor: "pointer" }}
                                    onClick={e => { e.preventDefault(); ChangeDate(1) }}>
                                    <i className="xi-angle-right font-size-22"></i>
                                  </span>
                                </span>
                              </div>
                              {/* <div data-v-20f59104="" className="notice column">
                                                      <div data-v-20f59104="" className="column" dangerouslySetInnerHTML={{ __html: rule }}></div>
                                                    </div> */}
                              <div data-v-20f59104="" className="calendar-wrap column">
                                <div
                                  data-v-20f59104=""
                                  className="day "
                                >
                                  {
                                    days.map((day, index) => {
                                      return (
                                        <div
                                          data-v-20f59104=""
                                          className={` ${day.className}`}
                                          key={index}
                                        >
                                          <span data-v-20f59104="" className="text">
                                            {isEmpty(window.lang[day.name]) ? day.name : window.lang[day.name]}
                                          </span>
                                        </div>)
                                    })
                                  }

                                </div>
                                <div data-v-20f59104="" className="calendar column">
                                  {dateArray.map((array, index) => {
                                    return (
                                      <Fragment key={index}>
                                        {array.map((day, dayIndex) =>
                                          !day ? (
                                            <div
                                              data-v-20f59104=""
                                              className="column"
                                              key={dayIndex}
                                            />
                                          ) : (
                                            <div
                                              data-v-20f59104=""
                                              className="column"
                                              key={dayIndex}
                                              style={
                                                date.getDate() === day
                                                  ? { border: " solid 1px #f7731b " }
                                                  : {}
                                              }
                                            >
                                              <span
                                                data-v-20f59104=""
                                                className={
                                                  "txt_date text " +
                                                  (histories.findIndex(item => item.day === day) >= 0
                                                    ? "green-text"
                                                    : dayIndex === 0 || dayIndex === 6
                                                      ? "red-text"
                                                      : "")
                                                }
                                              >
                                                {day < 10 ? "0" : ""}
                                                {day}
                                              </span>
                                              <div
                                                data-v-20f59104=""
                                                className="w-100"
                                              >
                                                {histories.findIndex(item => item.day === day) >= 0 ? (
                                                  <button data-v-20f59104="" className="button">
                                                    <span data-v-20f59104="" className="text">
                                                      <img
                                                        className="daily-check-img"
                                                        src="../images/dailycheck/check.png"
                                                        alt="체크"
                                                      />
                                                    </span>
                                                  </button>
                                                ) : (
                                                  <span
                                                    data-v-20f59104=""
                                                    className="text"
                                                    style={{ opacity: "0.6" }}
                                                  >
                                                    {isEmpty(window.lang["미출석"]) ? "미출석" : window.lang["미출석"]}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </Fragment>
                                    );
                                  })}

                                  {/* <div data-v-20f59104="" className="column">
                                                                <div data-v-20f59104="" className="row" style= {{ flexDirection: "row" }}><span data-v-20f59104=""
                                                                        className="text">
                                                                        30
                                                                    </span></div>
                                                                <div data-v-20f59104="" className="row" style= {{ flexDirection: "row" }}></div>
                                                            </div> */}
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  dailycheck: state.more.dailycheck,
  page: state.page
});

export default connect(
  mapStateToProps,
  { GetDailyCheckHistory }
)(AttendanceContent);



// WEBPACK FOOTER //
// ./src/components/account/AttendanceContent.js